import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import PrimaryButton from './PrimaryButton';
import { globalStyles as styles } from './style/gstheme';

class CancelChange extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      open: true
    };
  }

  exitChange = () => {
    this.setState({ open: false });
    this.props.onExitChange();
  }

  render() {

    const { message, classes } = this.props;

    return (
      <Dialog
        data-test="cancel-change"
        open={this.state.open}
        onClose={this.exitChange}
        aria-labelledby="cancelchange-dialog-title" >
        <DialogTitle disableTypography className={classes.mainHeading} id="areyousure-dialog-title">Things Have Changed!</DialogTitle>
        <DialogContent>
          {Array.isArray(message) ?
            message.map((line, index) => <DialogContentText key={index}>{line}</DialogContentText>
            )
            :
            <DialogContentText>{message}</DialogContentText>
          }
        </DialogContent>
        <DialogActions className={classes.dialogActions}>
          <PrimaryButton onClick={this.exitChange}>Close</PrimaryButton>
        </DialogActions>
      </Dialog>
    );
  }
}

CancelChange.propTypes = {
  message: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)
  ]),
  classes: PropTypes.object,
  onExitChange: PropTypes.func.isRequired
};

export default withStyles(styles)(CancelChange);